import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

function Register() {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    phoneNumber: "",
  });

  const navigate = useNavigate();

  const handleInputChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const registerUser = (e) => {
    e.preventDefault();

    fetch("https://stock.krishtec.co.in/stock/register.php", {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify(form),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.status === "success") {
          alert("Successfully Registered, Now Login with your details");
          navigate("/login");
        } else {
          alert("Error: " + result.message);
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 h-screen items-center place-items-center">
      <div className="w-full max-w-md space-y-8 p-10 rounded-lg">
        <div>
          <img
            className="mx-auto h-12 w-auto"
            src={require("../assets/logo.png")}
            alt="Logo"
          />
          <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">
            Register your account
          </h2>
        </div>
        <form className="mt-8 space-y-6" onSubmit={registerUser}>
          <div className="flex flex-col gap-4 rounded-md shadow-sm">
            <div className="flex gap-4">
              <input
                name="firstName"
                type="text"
                required
                className="w-full border rounded px-2 py-1"
                placeholder="First Name"
                value={form.firstName}
                onChange={handleInputChange}
              />
              <input
                name="lastName"
                type="text"
                required
                className="w-full border rounded px-2 py-1"
                placeholder="Last Name"
                value={form.lastName}
                onChange={handleInputChange}
              />
            </div>
            <input
              name="email"
              type="email"
              required
              className="w-full border rounded px-2 py-1"
              placeholder="Email Address"
              value={form.email}
              onChange={handleInputChange}
            />
            <input
              name="password"
              type="password"
              required
              className="w-full border rounded px-2 py-1"
              placeholder="Password"
              value={form.password}
              onChange={handleInputChange}
            />
            <input
              name="phoneNumber"
              type="tel"
              required
              className="w-full border rounded px-2 py-1"
              placeholder="Phone Number"
              value={form.phoneNumber}
              onChange={handleInputChange}
            />
          </div>

          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <input
                id="terms"
                name="terms"
                type="checkbox"
                className="h-4 w-4"
                required
              />
              <label htmlFor="terms" className="ml-2 text-sm text-gray-900">
                I agree to the terms & conditions
              </label>
            </div>
          </div>

          <button
            type="submit"
            className="w-full bg-indigo-600 text-white py-2 rounded hover:bg-indigo-500"
          >
            Sign Up
          </button>

          <p className="mt-2 text-center text-sm text-gray-600">
            Already have an account?{" "}
            <Link to="/login" className="text-indigo-600 hover:text-indigo-500">
              Sign in now
            </Link>
          </p>
        </form>
      </div>

      <div className="flex justify-center order-first sm:order-last">
        <img src={require("../assets/Login.png")} alt="Illustration" />
      </div>
    </div>
  );
}

export default Register;
